import PropTypes from 'prop-types';

const DropdownTrigger = ({ children }) => children;

DropdownTrigger.propTypes = {
  children: PropTypes.node.isRequired,
};

DropdownTrigger.displayName = 'DropdownTrigger';

export default DropdownTrigger;
